import MyStoreCard from './MyStoreCard'

export default MyStoreCard
